(() => {
  function init() {
    document.querySelectorAll('[data-jw-open]').forEach(button => {
      if (button.dataset.jwReady) return;
      button.dataset.jwReady = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.jwOpen);
        if (dialog && !dialog.open) {
          dialog.showModal();
          document.documentElement.classList.add('jw-dialog-open');
          dialog.addEventListener('close', () => {
            document.documentElement.classList.remove('jw-dialog-open');
            button.focus();
          }, { once: true });
        }
      });
    });
    document.querySelectorAll('.jw-dialog').forEach(dialog => {
      if (dialog.dataset.jwReady) return;
      dialog.dataset.jwReady = 'true';
      dialog.querySelectorAll('[data-jw-close],nav a').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) dialog.close(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
